import { Subscribable } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import WCCAttachment from 'models/attachments/attachment';
import pattern from 'patterns/videos';
import { WCCContentAttachmentsBlock } from '../blocks/attachments/attachments';
import WCCContentContext, { IWCCContentContext } from '../context';
import WCCContentDocument from '../document';
import WCCContentPatternRule from './pattern';
import WCCContentAttachmentsRule, {WCCContentAttachmentsRuleContext} from "./attachments";

export default class WCCContentVideosRule extends WCCContentAttachmentsRule {
    protected override pattern = pattern;

    constructor(attachments: Subscribable<Array<WCCAttachment>>) {
        super(attachments);
    }

    override parse(document: WCCContentDocument, context: WCCContentContext) {
        return super.parse(document, new WCCContentAttachmentsRuleContext(context));
    }

    protected override process(match: RegExpMatchArray, context: WCCContentAttachmentsRuleContext) {
        const [content, idsStr] = match;

        const ids = idsStr.split(';').map(id => this.decode(id.toLowerCase()));
        const attachments = this.getObservableAttachments(this.attachments, ids, context);

        return new WCCContentAttachmentsBlock({ content, attachments, showTranscript: false });
    };
}